<template>
  <validation-observer
    @submit.prevent="submitSuggestion"
    tag="form"
    ref="suggestion"
    v-slot="{ valid }"
  >
    <validation-provider
      rules="required|max:1500"
      name="suggestion"
      v-slot="{ errors }"
    >
      <b-field :message="errors" :type="{ 'is-danger': errors.length }">
        <b-input
          v-model="form.suggestion"
          rows="10"
          type="textarea"
          placeholder="Let us know what you would be interested in learning"
        >
        </b-input>
      </b-field>
    </validation-provider>
    <b-button
      :disabled="!valid || submitting"
      :loading="submitting"
      class="is-fullwidth tw-mt-4"
      native-type="submit"
      type="is-primary"
    >
      Send Suggestion
    </b-button>
  </validation-observer>
</template>

<script>
import Suggestion from '@/models/Suggestion'

export default {
  data() {
    return {
      submitting: false,
      form: {
        suggestion: ''
      }
    }
  },
  methods: {
    submitSuggestion() {
      this.submitting = true
      const suggestion = new Suggestion(this.form)
      suggestion
        .save()
        .then(suggestion => {
          this.form.suggestion = ''
          this.$buefy.snackbar.open({
            type: 'is-success',
            message:
              'Your resource suggestion has been successfully sent. Thank you!',
            position: 'is-top'
          })
          requestAnimationFrame(() => {
            this.$refs.suggestion.reset()
          })
        })
        .catch(() => {})
        .then(() => {
          this.submitting = false
        })
    }
  }
}
</script>
